/**
 * Reader settings whose meaning has to agree between client and server.
 */

/**
 * The reader translation style a user falls through to when they have never
 * chosen one — i.e. what an unset `readerTranslationStyle` means in practice.
 */
export const defaultTranslationStyle = "glossNew";
